import { TourBuilderStoreEvents } from '../../events/TourBuilderStoreEvents';
import { TourBuilderStoreIoC } from '../../tourBuilderIoC';
import { TourBuilderStore } from '../../tourBuilderStore';
import { SceneLink, SceneLinkGuid, SceneLinkHelper } from '../../types/SceneLink';
import { Position } from '@ael/core-api';

export type ChangeLinkCoordinatesUseCase = {
  linkGuid: SceneLinkGuid;
  tourId: number;
  position: Position;
};

export const changeLinkCoordinates = (
  params: ChangeLinkCoordinatesUseCase,
  getState: () => TourBuilderStore,
  services: TourBuilderStoreIoC,
  eventHandlers: Pick<TourBuilderStoreEvents, 'onLinkCoordinatesChanged'>
): Partial<TourBuilderStore> => {
  const store = getState();
  const link = store.links.get(params.linkGuid);
  if (!link) {
    return store;
  }

  const updatedLink = SceneLinkHelper.updateCoordinates(link, params.position);
  const newLinks = new Map<SceneLinkGuid, SceneLink>(store.links);
  newLinks.set(updatedLink.guid, updatedLink);

  eventHandlers.onLinkCoordinatesChanged.notify({
    guid: updatedLink.guid,
    position: params.position,
  });

  // Do not need to wait
  void services.storageClient.updateLink(updatedLink);

  return {
    links: newLinks,
  };
};
